import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=044025ea"
import script from "./my-tasks.ts?vue&type=script&lang=ts&external"
export * from "./my-tasks.ts?vue&type=script&lang=ts&external"
import style0 from "./my-tasks.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports